// useAuth Hook - Firebase Authentication State Management
import { useState, useEffect } from 'react';
import { User, onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase';

interface AuthState {
    user: User | null;
    loading: boolean;
}

export const useAuth = () => {
    const [authState, setAuthState] = useState<AuthState>({
        user: null,
        loading: true
    });

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setAuthState({
                user,
                loading: false
            });

            // Update localStorage for backward compatibility
            if (user) {
                localStorage.setItem('nescotech_session', 'true');
                localStorage.setItem('nescotech_user', JSON.stringify({
                    uid: user.uid,
                    email: user.email,
                    displayName: user.displayName,
                    photoURL: user.photoURL
                }));
            } else {
                localStorage.removeItem('nescotech_session');
                localStorage.removeItem('nescotech_user');
            }

            // Dispatch auth change event
            window.dispatchEvent(new Event('auth-change'));
        });

        return () => unsubscribe();
    }, []);

    const logout = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return {
        user: authState.user,
        loading: authState.loading,
        isAuthenticated: !!authState.user,
        logout
    };
};

export default useAuth;
